// DOM utility functions
export const getElement = (id) => document.getElementById(id)

export const showElement = (element) => {
  if (element) {
    element.style.display = 'block'
  }
}

export const hideElement = (element) => {
  if (element) {
    element.style.display = 'none'
  }
}

export const setOpacity = (element, opacity) => {
  if (element) {
    element.style.opacity = opacity
  }
}

export const clearVideoElement = (videoElement) => {
  if (videoElement) {
    videoElement.pause()
    videoElement.removeAttribute('src')
    videoElement.innerHTML = ''
  }
}

export const clearImageElement = (imageElement) => {
  if (imageElement) {
    imageElement.removeAttribute('src')
  }
}

export const getUrlParams = () => new URLSearchParams(window.location.search)
